<template>
  <nav class="d-flex align-items-center Page" aria-label="Page navigation example">
    <span v-if="page !== 1" @click="page = 1" class="page-item non-active">1</span>

    <svg v-if="page !== 1" @click="page--" class="page-item" width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg>
    <span v-if="max > 1" class="page-item page-link d-flex justify-content-center align-items-center">
      <input v-model="inputValue" @keydown="keydown" @blur="blur">
    </span>
    <svg v-if="max > 1 && page !== max" @click="page++" class="page-item" width="18" height="18" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path></svg>

    <span v-if="max > 1 && page !== max" @click="page = max" class="page-item non-active">{{ max }}</span>
  </nav>
</template>

<script>

export default {
  props: {
    value: Number,
    max: Number,
  },
  data() {
    return {
      page: this.$route.query.page || this.value || 1,
      inputValue: this.$route.query.page || this.value || 1,
    }
  },
  methods: {
    keydown({ key }) {
      if (key === "Enter") {
        const val = parseInt(this.inputValue, 10)

        if (!isNaN(val)) this.updateModel(val)
        else this.blur()
      }
    },
    updateModel(page = this.page) {
      if (page <= 0) {
        this.page = 1
      } else if (page > this.max) {
        this.page = this.max
      }
      this.$emit("input", page)
    },
    blur() {
      this.inputValue = this.value
    },
  },
  watch: {
    value(val) {
      this.page = val
    },
    page() {
      this.inputValue = this.page
      this.updateModel()
    },
  },
}

</script>

<style scoped>

input {
  width: 25px;
  text-align: center;
}

.Page {
  display: flex !important;
  color: #6D6E71 !important;
}

.page-item {
  cursor: pointer;
  font-size: 16px !important;
}

.page-item + .page-item {
  margin-left: 6px;
}

.non-active {
  display: inline-block;
  padding: 8px;
  text-decoration: underline;
}

.active .page-link {
  color: white !important;
  background-color: var(--mint-green) !important;
  border: 1px solid var(--mint-green) !important;
}

</style>
